<div class="fb-add-field">
  <button class="fb-add-field__btn" (click)="toggleDropdown()">
    <i class="fa-solid fa-plus"></i> Add Field
  </button>
  <div class="fb-add-field__dropdown" *ngIf="showDropdown">
    <div class="fb-add-field__search">
      <input
        #searchInput
        type="text"
        class="fb-add-field__search-input"
        [(ngModel)]="searchQuery"
        placeholder="Search field types..."
        (keydown.escape)="toggleDropdown()" />
    </div>
    <div class="fb-add-field__list">
      <button
        *ngFor="let ft of filteredFieldTypes; trackBy: trackByFieldType"
        class="fb-add-field__option"
        (click)="selectFieldType(ft)">
        <i [class]="ft.icon" class="fb-add-field__option-icon"></i>
        <span>{{ ft.displayName }}</span>
      </button>
      <div class="fb-add-field__empty" *ngIf="filteredFieldTypes.length === 0">
        No field types match "{{ searchQuery }}"
      </div>
    </div>
  </div>
</div>
